import {Trans} from 'react-i18next';
import dayjs from 'dayjs';
import {TFunction} from 'i18next';

const getTimeErrorMessage = (hoursBefore: number, t: TFunction) => {
  const hoursErrorMessage = (
    <Trans i18nKey="last_hours_before_checkin" t={t} values={{hours: hoursBefore}} />
  );
  const weekErrorMessage = <>{t('one_week_before_checkin')}</>;
  const daysMessage = (
    <Trans i18nKey="last_days_before_checkin" t={t} values={{days: hoursBefore / 24}} />
  );
  return hoursBefore === 168
    ? weekErrorMessage
    : hoursBefore > 72
    ? daysMessage
    : hoursErrorMessage;
};

function checkIfReservationIsBeforeTimeRange(
  checkinDate?: string,
  hoursBefore?: number,
): boolean {
  if (!checkinDate || !hoursBefore) return false;
  const checkin = dayjs.utc(checkinDate).utc(true);
  const now = dayjs.utc();
  const hoursBeforeCheckin = checkin.subtract(hoursBefore, 'hour');

  return now.isBetween(hoursBeforeCheckin, checkin) || now.isAfter(checkin);
}

export {checkIfReservationIsBeforeTimeRange, getTimeErrorMessage};
